import { Injectable } from '@angular/core';
import { Storage, ref, uploadBytesResumable, getDownloadURL } from '@angular/fire/storage'; // Updated imports

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {

  constructor(private storage: Storage) { } // Updated constructor injection

  uploadFile(file: File, filePath: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const storageRef = ref(this.storage, filePath); // Use ref() function
      const uploadTask = uploadBytesResumable(storageRef, file, { contentType: file.type }); // Use uploadBytesResumable()

      // Listen for state changes, errors, and completion of the upload.
      uploadTask.on('state_changed',
        (snapshot) => {
          // Optional: Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          // const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          // console.log('Upload is ' + progress + '% done');
        },
        (error) => {
          // Handle unsuccessful uploads
          console.error("File upload error:", error);
          reject(error);
        },
        () => {
          // Handle successful uploads on complete
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => { // Use getDownloadURL()
            console.log('File available at', downloadURL);
            resolve(downloadURL);
          }).catch(error => {
            console.error("Error getting download URL:", error);
            reject(error);
          });
        }
      );
    });
  }
}